import React from 'react'

import { useIntl } from 'react-intl'
import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { modalResumeAutoSave } from 'Pages/MessageEdit/recoil/state/modals'

import {
  discardAutosaveCallback,
  openPreviewCallback,
  resumeAutosaveCallback
} from 'Pages/MessageEdit/recoil/callbacks/callbacks'
import styled from '@emotion/styled'

export const ModalResumeAutoSave = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalResumeAutoSave)
  const discardAutosave = useRecoilCallback(discardAutosaveCallback, [])
  const resumeAutosave = useRecoilCallback(resumeAutosaveCallback, [])
  const openPreview = useRecoilCallback(openPreviewCallback, [])
  const handleDiscard = () => {
    discardAutosave()
  }

  const handleResume = () => {
    resumeAutosave()
  }

  const handlePreview = () => {
    openPreview()
  }

  return (
    <Modal
      show={show}
      showClose={false}
      closeOnOverlayClick={false}
      data-mu-test='modal-message-resume-autosave'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ModalTitleForContinueEditingTemplate'
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.Bee.ModalDescriptionForContinueEditingTemplate'
        })}
      </ModalBody>
      <ModalFoot>
        <Flex width='100%' justifyContent='space-between'>
          <StyledNeutralButton
            data-mu-test='button-template-autosave-discard'
            onClick={handleDiscard}
            kind='neutral'
          >
            {intl.formatMessage({
              id: 'Load.Bee.ModalForContinueEditingTemplateStartNewBtn'
            })}
          </StyledNeutralButton>

          <FlexItem>
            <Button
              data-mu-test='button-template-autosave-preview'
              onClick={handlePreview}
              kind='secondary'
            >
              {intl.formatMessage({
                id: 'Load.Bee.ModalForContinueEditingTemplatePreviewBtn'
              })}
            </Button>

            <Button
              data-mu-test='button-template-autosave-resume'
              onClick={handleResume}
              kind='secondary'
            >
              {intl.formatMessage({
                id: 'Load.Bee.ModalForContinueEditingTemplateContinueBtn'
              })}
            </Button>
          </FlexItem>
        </Flex>
      </ModalFoot>
    </Modal>
  )
}

const StyledNeutralButton = styled(Button)`
  margin-left: 0 !important;
`
